module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', [_c('div', {
    staticClass: "nav flex flex-center"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about-us',
        params: {
          liName: 'about'
        }
      },
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about-us',
        params: {
          liName: 'invoice'
        }
      },
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("索取发票")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about-us',
        params: {
          liName: 'refund'
        }
      },
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("退款说明")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about-us',
        params: {
          liName: 'pay'
        }
      },
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("支付方式")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about-us',
        params: {
          liName: 'contact'
        }
      },
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about-us',
        params: {
          liName: 'protocol'
        }
      },
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("用户协议")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "link-con flex flex-center"
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _vm._v(" "), (_vm.$route.path === '/') ? _c('div', {
    staticClass: "right flex"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n            友情链接\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "friend-link"
  }, _vm._l((_vm.friendLinks), function(item) {
    return _c('div', {
      key: item.title
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.title))])])
  }))]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left flex flex-center",
    staticStyle: {
      "flex": "3"
    }
  }, [_c('div', [_c('a', {
    staticClass: "finance_btn",
    attrs: {
      "href": "http://tax.qiyewan.com",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "82px",
      "height": "81px",
      "margin": "5px 5px"
    },
    attrs: {
      "src": "//v3.cdn.qiyewan.com/footer-internal-finance.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("内部财税")])]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "82px",
      "height": "81px",
      "margin": "5px 0"
    },
    attrs: {
      "src": "//v3.cdn.qiyewan.com/erweima.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("关注服务号")])]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "90px",
      "height": "91px"
    },
    attrs: {
      "src": "//v3.cdn.qiyewan.com/erweima1.jpg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("关注订阅号")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom flex-center"
  }, [_c('p', [_vm._v("\n        Copyright @ 2015-2019 www.qiyewan.com 企业湾 备案号：\n        "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/index",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("沪ICP备15043250号-2")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding-left": "30px"
    },
    attrs: {
      "href": "//www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202004875",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": "//www.beian.gov.cn/img/ghs.png",
      "alt": "ghs"
    }
  }), _vm._v("\n          沪公网安备 31011202004875号\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-203aa86a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/OldFooter.vue
// module id = 1015
// module chunks = 40